import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { useTranslation } from 'react-i18next';
import { DraggableTrackRow } from './DraggableTrackRow';
import { IDraggableTrack, IDroppableVolume } from './ReorderTracks';

interface DroppableVolumeTableProps {
  volume: IDroppableVolume;
  formatHeader: (i: number) => string;
  activeTrack?: IDraggableTrack;
}

export function DroppableVolumeTable({
  volume,
  formatHeader,
  activeTrack,
}: DroppableVolumeTableProps) {
  const { setNodeRef } = useDroppable({
    id: volume.id,
  });
  const { t } = useTranslation();

  return (
    <SortableContext
      items={volume.tracks}
      key={volume.id}
      strategy={verticalListSortingStrategy}
    >
      <div ref={setNodeRef}>
        <div className="track-header">{formatHeader(volume.volumeNumber)}</div>
        <table className="reorder-tracks-grid">
          <thead>
            <tr>
              <th className="track-handle"></th>
              <th className="track-number">#</th>
              <th>{t('track.trackTitle')}</th>
              <th>{t('track.version')}</th>
              <th>{t('track.displayArtist')}</th>
              <th>{t('track.isrc')}</th>
              <th className="track-duration">
                <div className="icon-header-cell">
                  <i className="far fa-clock fa-lg"></i>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {volume.tracks.map((track: any) => (
              <DraggableTrackRow
                key={track.id}
                id={track.id}
                track={track.track}
                showShadow={track.id === activeTrack?.id}
              />
            ))}
          </tbody>
        </table>
      </div>
    </SortableContext>
  );
}
